<template>
    <div id="app">
        <nav-header></nav-header>
        <router-view v-if="show"></router-view>
    </div>
</template>

<script>
    import navHeader from '@/components/header/header';
    export default {
        name: 'app',
        components: {
            navHeader
        },
        data() {
            return {
                showHeader: false,
                show: false
            };
        },
        methods: {
            getUserInfo() {
                this.$post('/UserCenter/getSimpleUserInfo', {}, (resp) => {
                    if (resp.code == 1) {
                        this.$store.commit('SET_USER_INFO', resp.data);
                    }
                });
            },
            getLoginStatus() {
                this.$post('/User/getUserLoginStatus', {}, (resp) => {
                    if (resp.code == 1) {
                        if (resp.data.status == 1) {
                            this.getUserInfo();
                        }
                    }
                });
            },
            /** 无法通过vuerouter获取自路由中的param??? */
            getUrlPara(name) {
                var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
                var r = window.location.search.substr(1).match(reg);

                if (r != null) return (r[2]); return null;
            },
            oauth(token, callback) {
                this.$post('/User/oauthLogin', {
                    oauth_token: token
                }, (resp) => {
                    if (resp.code == 1) {
                        callback();
                    } else {
                        this.$message({
                            type: 'warning',
                            message: resp.msg,
                            center: true
                        });
                    }
                });
            }
        },
        created() {
            let ticket = this.getUrlPara('ticket');
            let token = this.getUrlPara('oauth_token');

            if (token) {
                this.oauth(token, () => {
                    this.show = true;
                    this.getLoginStatus();
                    this.$router.replace({
                        query: {
                            oauth_token: null
                        }
                    });
                });
            } else if (ticket) {
                this.show = true;
                // 重置sessionticket
                this.setSessionTicket(ticket);
                this.getLoginStatus();
            } else {
                this.show = true;
                this.getLoginStatus();
            }
        }
    };
</script>

<style lang="less">
    @import './assets/css/common.less';
</style>



// WEBPACK FOOTER //
// src/App.vue